import {
    clearAssignment,
    clearAssignments,
    clearNotificationCount,
    currentState,
    getNotificationCount,
    hasNewAssignment,
    hasUnseenAssignment,
    incrementNotificationCount,
    markAssignmentSeen,
    newAssignmentCount,
    setNotificationCount,
    trackAssignmentIds
} from './state';
import { renderTabCount as renderMyAssignmentsTabCount } from './tab_badge';
import { applyAssignmentDots, hideBottomNotification, updateBottomNotification } from './assignment_hooks';

let myAssignmentsHasRendered = false;

window.assignmentResourceNotifications = {
    increment,
    clearMyAssignmentsNotifications,
    notifyAssignmentsChanged,
    notifyAssignmentResourceSaved,
    notifyImportedAssignmentResources,
    hasNewAssignment,
    hasUnseenAssignment,
    clearAssignment,
    clearAssignments,
    markAssignmentSeen,
    currentState,
    renderTabCount,
    applyAssignmentDots,
    updateBottomNotification,
    refreshMyAssignmentsNotifications,
    afterMyAssignmentsRendered,
    afterVisibleBodyAssignmentsRendered,
    myAssignmentsTabIsActive
};

function renderTabCount() {
    renderMyAssignmentsTabCount(getNotificationCount());
}

function notifyAssignmentsChanged({ assignmentIds = [] } = {}) {
    const trackedAssignmentIds = trackAssignmentIds(assignmentIds);
    const notificationCount = assignmentIds.length > 0 ? trackedAssignmentIds.length : 1;

    if (notificationCount === 0) return false;

    increment(notificationCount);
    return true;
}

function notifyAssignmentResourceSaved(assignmentResourceIds, { clearTabCount = false } = {}) {
    const assignmentIds = Array.isArray(assignmentResourceIds) ? assignmentResourceIds : [assignmentResourceIds];
    const presentAssignmentIds = assignmentIds.filter((assignmentResourceId) => assignmentResourceId != null && assignmentResourceId !== '');

    if (presentAssignmentIds.length === 0) return false;

    const assignmentsChanged = notifyAssignmentsChanged({ assignmentIds: presentAssignmentIds });

    if (clearTabCount) {
        clearMyAssignmentsNotifications();
    }

    return assignmentsChanged;
}

function notifyImportedAssignmentResources(assignmentResourceIds) {
    return notifyAssignmentResourceSaved(assignmentResourceIds, { clearTabCount: myAssignmentsTabIsActive() });
}

function increment(count = 1) {
    incrementNotificationCount(count);
    renderTabCount();
}

function clearMyAssignmentsNotifications() {
    clearNotificationCount();
    renderTabCount();
}

function afterMyAssignmentsRendered() {
    myAssignmentsHasRendered = true;
    clearNotificationCount();
    refreshMyAssignmentsNotifications();
}

function refreshMyAssignmentsNotifications() {
    renderTabCount();
    applyAssignmentDots();
    updateBottomNotification();
}

function afterVisibleBodyAssignmentsRendered() {
    hideBottomNotification();

    if (importPastAssignmentsInProgress()) {
        setNotificationCount(newAssignmentCount());
        renderTabCount();
        return;
    }

    if (!myAssignmentsHasRendered) return;

    clearAssignments();
}

function myAssignmentsTabIsActive() {
    const myAssignmentsTab = document.querySelector('[data-tab-key="mine"]');
    return myAssignmentsTab?.closest('.assignment_resource__main_panel__top_bar__tabs-tab-is_active') != null;
}

function importPastAssignmentsInProgress() {
    return document.getElementById('assignment-resource-import-feedback') != null;
}

document.addEventListener('turbolinks:load', function () {
    if (myAssignmentsTabIsActive()) {
        myAssignmentsHasRendered = true;
    }

    renderTabCount();
});
